import ImageSwiper from "../image-swiper/ImageSwiper";
import { SmProductHeader } from "../layout/SmProductHeader";

export const ProductBanner = ({ d }: { d?: ProductDetailResponse }) => {
  const images = d?.featuredFiles?.map((x) => x.src);
  if (!images || images.length <= 0) return null;
  return (
    <div className="relative sm:pt-5">
      <SmProductHeader d={d} />
      <ImageSwiper images={images} />
    </div>
  );
};
